import paginationParams from '@/constants/paginationParams';

export default {
  isLoading: false,
  isLoaded: false,
  data: [],
  paginationParams,
};
